<div *ngIf="isOpen" class="filter-drawer" role="dialog" aria-modal="true">
  <div class="filter-drawer__backdrop" (click)="onClose()"></div>

  <aside class="filter-drawer__panel" (click)="$event.stopPropagation()">
    <header class="filter-drawer__header">
      <div>
        <h2>{{ title }}</h2>
        <p>{{ subtitle }}</p>
      </div>

      <button
        type="button"
        class="filter-drawer__close"
        (click)="onClose()"
        aria-label="Close filter drawer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </button>
    </header>

    <form class="filter-drawer__form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="filter-drawer__body">
        <div class="filter-drawer__grid">
          <div
            *ngFor="let field of fields; trackBy: trackByField"
            class="filter-drawer__field"
            [class.filter-drawer__field--full]="field.fullWidth"
          >
            <label class="filter-drawer__label" [for]="field.key">
              {{ field.label }}
            </label>

            <p *ngIf="field.hint" class="filter-drawer__hint">
              {{ field.hint }}
            </p>

            <ng-container [ngSwitch]="field.type">
              <textarea
                *ngSwitchCase="'textarea'"
                class="filter-drawer__control filter-drawer__textarea"
                [id]="field.key"
                [attr.placeholder]="field.placeholder || ''"
                [attr.rows]="field.rows || 4"
                [readonly]="field.readonly"
                [formControlName]="field.key"
              ></textarea>

              <select
                *ngSwitchCase="'select'"
                class="filter-drawer__control"
                [id]="field.key"
                [formControlName]="field.key"
              >
                <option [ngValue]="''">
                  {{ field.placeholder || 'Select an option' }}
                </option>
                <option
                  *ngFor="let option of field.options || []"
                  [ngValue]="option.value"
                  [disabled]="!!option.disabled"
                >
                  {{ option.label }}
                </option>
              </select>

              <div *ngSwitchCase="'searchable-select'" class="filter-drawer__searchable">
                <button
                  type="button"
                  class="filter-drawer__control filter-drawer__search-trigger"
                  [class.filter-drawer__control--open]="openSearchableFieldKey === field.key"
                  (click)="toggleSearchableSelect(field.key)"
                >
                  <span class="filter-drawer__search-trigger-copy">
                    {{ getSelectedSearchableOptionLabel(field) }}
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 9-7 7-7-7"
                    />
                  </svg>
                </button>

                <div
                  *ngIf="openSearchableFieldKey === field.key"
                  class="filter-drawer__search-dropdown"
                >
                  <div class="filter-drawer__search-input-wrap">
                    <input
                      type="text"
                      class="filter-drawer__search-input"
                      [placeholder]="field.searchablePlaceholder || 'Search options'"
                      [(ngModel)]="searchableTerms[field.key]"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </div>

                  <div class="filter-drawer__search-results">
                    <button
                      *ngFor="let option of getFilteredOptions(field)"
                      type="button"
                      class="filter-drawer__search-option"
                      [disabled]="!!option.disabled"
                      (click)="selectSearchableOption(field.key, option)"
                    >
                      <span>{{ option.label }}</span>
                      <small *ngIf="option.description">{{ option.description }}</small>
                    </button>

                    <div
                      *ngIf="getFilteredOptions(field).length === 0"
                      class="filter-drawer__empty-state"
                    >
                      No matching options found.
                    </div>
                  </div>
                </div>
              </div>

              <label *ngSwitchCase="'checkbox'" class="filter-drawer__checkbox-single">
                <input type="checkbox" [formControlName]="field.key" />
                <span>{{ field.placeholder || field.label }}</span>
              </label>

              <div *ngSwitchCase="'checkbox-group'" class="filter-drawer__options">
                <label
                  *ngFor="let option of field.options || []"
                  class="filter-drawer__option-card"
                >
                  <input
                    type="checkbox"
                    [checked]="isCheckboxGroupChecked(field.key, option.value)"
                    [disabled]="!!option.disabled"
                    (change)="onCheckboxGroupChange(field.key, option.value, $any($event.target).checked)"
                  />
                  <span>{{ option.label }}</span>
                  <small *ngIf="option.description">{{ option.description }}</small>
                </label>
              </div>

              <div *ngSwitchCase="'radio'" class="filter-drawer__options">
                <label
                  *ngFor="let option of field.options || []"
                  class="filter-drawer__option-card"
                >
                  <input
                    type="radio"
                    [name]="field.key"
                    [value]="option.value"
                    [formControlName]="field.key"
                    [disabled]="!!option.disabled"
                  />
                  <span>{{ option.label }}</span>
                  <small *ngIf="option.description">{{ option.description }}</small>
                </label>
              </div>

              <input
                *ngSwitchDefault
                class="filter-drawer__control"
                [id]="field.key"
                [type]="field.type"
                [attr.inputmode]="field.type === 'number' ? 'numeric' : null"
                [attr.placeholder]="field.placeholder || ''"
                [attr.min]="field.min"
                [attr.max]="field.max"
                [attr.step]="field.step"
                [readonly]="field.readonly"
                [formControlName]="field.key"
              />
            </ng-container>
          </div>
        </div>
      </div>

      <footer class="filter-drawer__footer">
        <button type="button" class="filter-drawer__reset" (click)="onReset()">
          {{ resetLabel }}
        </button>
        <button type="submit" class="filter-drawer__submit">
          {{ submitLabel }}
        </button>
      </footer>
    </form>
  </aside>
</div>
